import React, {useEffect, useState} from "react";
import {AppName, GenRouteUrls, Keys, Modules, ReqUrls} from "../config/AppConfig";
import {Anchor, Flexbox, GridBox, Image, Label, MsgBox, Select} from "../../common/fusion-ui";
import {useTheme} from "../../common/ProjectThemeProvider";
import {focusFormIdElement, printError, printLog, sendRequest} from "../utils/AppUtils";
import {addClass, checkNullArr, checkNullStr, getJsonValue, getElement, isBoolTrue, isJsonValueTrue, setTabTitle} from "../../common/fusion-ui/utils/ReactUtils";
import {CssVariant} from "../../common/fusion-ui/config/FusionConfig";
import {useLocation, useNavigate} from "react-router-dom";
import {AuthPageLayout, InvalidBypassTokenLabel, ThemedButton, ThemedDialog, ThemedInput} from "../index";
import {useSubdomainData} from "../context/SubdomainProvider";
import {useInternetStatus} from "../../common/fusion-ui/hook";

const RequestAccessPage = React.memo(() => {
    const TAG = 'RequestAccessPage';

    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const {subdomainData, isSubdomainValid} = useSubdomainData();
    const {isOnline} = useInternetStatus();

    const HowYouFoundUsSrcs = ['From a colleague', 'From a company', 'Google', 'News article', 'Other'];
    const FOCUS_DELAY = 2000;
    const INPUT_H = '38px';
    // const DEF_IMG = getBrowserCookie(Keys.reqPageImg, `https://images.unsplash.com/photo-1579547621113-e4bb2a19bdd6`);
    const DEF_IMG = `https://images.unsplash.com/photo-1579547621113-e4bb2a19bdd6`;

    const Fields = {
        //form
        fullName: 'fullName',
        email: 'email',
        mobile: 'mobile',
        landline: 'landline',
        city: 'city',
        companyName: 'companyName',
        howYouFoundUsSrcs: 'howYouFoundUsSrcs',
        howYouFoundSelectedSrc: "howYouFoundSelectedSrc",
        howYouFoundColleague: 'howYouFoundColleague',

        //form-msgs
        fullNameMsg: 'fullNameMsg',
        emailMsg: 'emailMsg',
        mobileMsg: 'mobileMsg',
        landlineMsg: 'landlineMsg',
        cityMsg: 'cityMsg',
        companyNameMsg: 'companyNameMsg',
        howYouFoundColleagueMsg: 'howYouFoundColleagueMsg',

        //submit
        submitAsLoading: 'submitAsLoading',
        submitDisable: 'submitDisable',

        //panel msg
        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        //success-dialog
        showSuccessDialog: 'showSuccessDialog',
        successDialogContent: 'successDialogContent',
    };
    const [fieldsData, setFieldsData] = useState({});

    const FieldConfigs = {
        [Fields.fullName]: {
            regex: /^[a-zA-Z _-]+$/, maxLen: 200,
        }, [Fields.email]: {
            regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, maxLen: 200,
        }, [Fields.mobile]: {
            maxLen: 200,
        }, [Fields.landline]: {
            maxLen: 200,
        }, [Fields.city]: {
            regex: /^[a-zA-Z\s- ]*$/, maxLen: 200,
        }, [Fields.companyName]: {
            regex: /^[a-zA-Z0-9-_+.() ]*$/, maxLen: 200,
        }, [Fields.howYouFoundColleague]: {
            regex: /^[a-zA-Z _-]+$/, maxLen: 200,
        },
    };

    useEffect(() => {
        setTabTitle(Modules.RequestAccess);
        if (!checkNullArr(getField(Fields.howYouFoundUsSrcs))) {
            const pages = HowYouFoundUsSrcs.map(item => ({id: item, text: item}));
            // const pages = HowYouFoundUsSrcs.map(item => item);
            updateField(Fields.howYouFoundUsSrcs, pages)
        }
        // log('useEffect.cookies:', getBrowserCookie([Keys.theme, Keys.reqPageImg, Keys.loginPageImg]));
    }, []);

    return (<>
        <AuthPageLayout className={'py-sm-4'} px={0} py={1}>
            {/*<AutoCompleteView*/}
            {/*    options={[*/}
            {/*        {id: 1, name: 'Guest User', email: 'guest@gmail.com', icon: 'icon', selected: false, removable: true},*/}
            {/*        {id: 2, name: 'Guest User 2', email: 'guest2@gmail.com', icon: 'icon', selected: true, removable: false},*/}
            {/*        {id: 3, name: 'Guest User 3', email: 'guest3@gmail.com', icon: 'icon', selected: true, removable: true},*/}
            {/*    ]}*/}
            {/*/>*/}
            <GridBox className={'m-0 p-0 auth-page bg-infox al-start-sm'}
                     sm={12} md={[6, 6]} gap={0}
                     alignAt={'start'} justifyAt={'center'}
                     minHeight={'90vh'}
            >
                {/*left - imgPanelData image*/}
                {canShowImage() && <div className={'m-0 p-0 pt-1 px-3 d-none-smx h-100 auth-img-wrapper'}>
                    <Image
                        wrapperClassName={`w-100 h-100 rounded-8 overflow-hidden select-none`}
                        className={`auth-ra-img transition-sm`}
                        // src={getJsonValue(subdomainData, Keys.subdomain_RequestAccessImage)}
                        src={getJsonValue(subdomainData, Keys.subdomain_RequestAccessImage, DEF_IMG)}
                        width={'100%'}
                        height={'760px'}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>}

                {/*right - panel*/}
                <div className={'m-0 p-0x row jc-center al-centerx al-start-smx xh-100 bg-dangerx auth-panel-right'}>
                    <div
                        className={`m-0 p-0x px-sm-5x bg-infox col-sm-8 col-md-10 col-lg-8 auth-panel-wrapper ${canShowImage() ? 'has-image' : 'imageless'}`}>
                        {/*invalid-token-msg*/}
                        <InvalidBypassTokenLabel/>

                        {/*top*/}
                        <div className={'m-0 p-0'}>
                            <Label className={'fw-bold fs-xl text-nowrapx'} textAt={'start'}>
                                <span className={''} style={{color: theme.text90}}>
                                    {` ${Modules.RequestAccess}`} For
                                 </span>
                                <span className={''} style={{color: theme.primary}}>
                                    {" "}{getJsonValue(subdomainData, Keys.subdomain_Name, AppName)}
                                </span>
                            </Label>

                        </div>

                        {/*form*/}
                        <div className={'m-0 p-0 mt-1 auth-form'}>
                            <form>
                                {/*fullName*/}
                                <ThemedInput
                                    mainWrapperClassName={`w-100 pb-2`}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'name'}
                                    id={Fields.fullName}
                                    label={'Your Name'}
                                    placeholder={'Enter your name'}
                                    value={getField(Fields.fullName)}
                                    pattern={FieldConfigs[Fields.fullName].regex}
                                    validate={true}
                                    required={true}
                                    msg={getField(Fields.fullNameMsg)}
                                    onChange={(e, valid) => {
                                        const value = e.target.value;
                                        if ((value + '').length <= FieldConfigs[Fields.fullName].maxLen) {
                                            updateField(Fields.fullName, value);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                highlightIdField(Fields.fullName, false, Fields.fullNameMsg, '');
                                            }
                                        }
                                    }}
                                />

                                {/*email*/}
                                <ThemedInput
                                    mainWrapperClassName={`w-100 pb-2`}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'email'}
                                    id={Fields.email}
                                    label={'Email Address'}
                                    placeholder={'Enter your email address'}
                                    value={getField(Fields.email)}
                                    required={true}
                                    // pattern={FieldConfigs[Fields.email].regex}
                                    // validate={true}
                                    msg={getField(Fields.emailMsg)}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        if (value.length <= FieldConfigs[Fields.email].maxLen) {
                                            updateField(Fields.email, value);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                // highlightIdField(Fields.email, false, Fields.emailMsg, '');

                                                let valid = FieldConfigs[Fields.email].regex.test(value);
                                                log('email.onChange.value:', value, 'valid:', valid);
                                                highlightIdField(Fields.email, !valid, Fields.emailMsg, valid ? '' : 'Invalid email');
                                            }
                                        }
                                    }}
                                />
                                {/*landline*/}
                                <ThemedInput
                                    mainWrapperClassName={`w-100 pb-2`}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'mobile'}
                                    id={Fields.landline}
                                    label={'Phone No./Landline'}
                                    placeholder={'Enter phone number'}
                                    value={getField(Fields.landline)}
                                    msg={getField(Fields.landlineMsg)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if ((value + '').length <= FieldConfigs[Fields.landline].maxLen) {
                                            let sanitizedInput = (value + '')
                                                .replace(/[^0-9\s\-+ ]/g, '')
                                                .replaceAll("++", "+").replaceAll("--", "-")
                                                .replaceAll("-+", "-").replaceAll("+-", "+")
                                                .replaceAll("  ", " ");
                                            updateField(Fields.landline, sanitizedInput);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                highlightIdField(Fields.landline, false, Fields.landlineMsg, '');
                                            }
                                        }
                                    }}
                                />
                                {/*mobile*/}
                                <ThemedInput
                                    mainWrapperClassName={`w-100 pb-2`}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'mobile'}
                                    id={Fields.mobile}
                                    label={'Mobile No.'}
                                    placeholder={'Enter mobile number'}
                                    value={getField(Fields.mobile)}
                                    required={true}
                                    msg={getField(Fields.mobileMsg)}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if ((value + '').length <= FieldConfigs[Fields.mobile].maxLen) {
                                            let sanitizedInput = (value + '')
                                                .replace(/[^0-9\s\-+ ]/g, '')
                                                .replaceAll("++", "+").replaceAll("--", "-")
                                                .replaceAll("-+", "-").replaceAll("+-", "+")
                                                .replaceAll("  ", " ");
                                            updateField(Fields.mobile, sanitizedInput);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                highlightIdField(Fields.mobile, false, Fields.mobileMsg, '');
                                            }
                                        }
                                    }}
                                />
                                {/*city*/}
                                <ThemedInput
                                    mainWrapperClassName={`w-100 pb-2`}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'text'}
                                    id={Fields.city}
                                    label={'City'}
                                    placeholder={'Enter city'}
                                    value={getField(Fields.city)}
                                    pattern={FieldConfigs[Fields.city].regex}
                                    validate={true}
                                    required={true}
                                    msg={getField(Fields.cityMsg)}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        if (value.length <= FieldConfigs[Fields.city].maxLen) {
                                            updateField(Fields.city, value);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                highlightIdField(Fields.city, false, Fields.cityMsg, '');
                                            }
                                        }
                                    }}
                                />
                                {/*companyName*/}
                                <ThemedInput
                                    mainWrapperClassName={`w-100 pb-2`}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'text'}
                                    id={Fields.companyName}
                                    label={'Company Name'}
                                    placeholder={'Name of healthcare company'}
                                    value={getField(Fields.companyName)}
                                    pattern={FieldConfigs[Fields.companyName].regex}
                                    validate={true}
                                    required={true}
                                    msg={getField(Fields.companyNameMsg)}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        if (value.length <= FieldConfigs[Fields.companyName].maxLen) {
                                            updateField(Fields.companyName, value);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                highlightIdField(Fields.companyName, false, Fields.companyNameMsg, '');
                                            }
                                        }
                                    }}
                                />

                                {/*howYouFoundUsSrcs*/}
                                <Select
                                    id={Fields.howYouFoundUsSrcs}
                                    wrapperClassName={`w-100`}
                                    labelClassName={`px-1 w-100 text-input-label`}
                                    innerWrapperClassName={'w-100'}
                                    className={`w-100 py-2 rounded-3`}
                                    variant={'primary'}
                                    justifyAt={'start'}
                                    style={{height: INPUT_H}}
                                    labelStyle={{color: theme.text40}}
                                    label={'How did you found us'}
                                    textKey={'text'}
                                    idKey={'id'}
                                    placeholder={'Choose an option'}
                                    options={getField(Fields.howYouFoundUsSrcs, [])}
                                    defOption={getField(Fields.howYouFoundSelectedSrc)}
                                    onChange={(e, text, value) => {
                                        log('howYouFoundUsSrcs.Select.onChange::text:', text, "value:", value);
                                        updateField(Fields.howYouFoundSelectedSrc, value);
                                        updateField(Fields.howYouFoundColleague, '');
                                    }}
                                />

                                {/*howYouFoundColleague*/}
                                {(getField(Fields.howYouFoundSelectedSrc) == HowYouFoundUsSrcs[0]) && <ThemedInput
                                    mainWrapperClassName={`w-100`}
                                    wrapperClassName={'pt-3'}
                                    className={`py-2`}
                                    style={{height: INPUT_H}}
                                    type={'text'}
                                    id={Fields.howYouFoundColleague}
                                    label={"Colleague's Name"}
                                    placeholder={"Colleague's Name"}
                                    value={getField(Fields.howYouFoundColleague)}
                                    pattern={FieldConfigs[Fields.howYouFoundColleague].regex}
                                    validate={true}
                                    required={true}
                                    msg={getField(Fields.howYouFoundColleagueMsg)}
                                    onChange={(e) => {
                                        const value = e.target.value + '';
                                        if (value.length <= FieldConfigs[Fields.howYouFoundColleague].maxLen) {
                                            updateField(Fields.howYouFoundColleague, value);
                                            if (checkNullStr(value)) {
                                                panelLog('');
                                                highlightIdField(Fields.howYouFoundColleague, false, Fields.howYouFoundColleagueMsg, '');
                                            }
                                        }
                                    }}
                                />}

                                {/*msg-box*/}
                                {(checkNullStr(getField(Fields.panelMsg)) || !isOnline) &&
                                    <MsgBox color={!isOnline ? 'red' : getField(Fields.panelMsgColor, theme.text90)}>
                                        {!isOnline ? `You're offline!` : getField(Fields.panelMsg)}
                                    </MsgBox>}


                                {/*submit*/}
                                <div className={'m-0 p-0 mt-3 mb-1 w-100'}>
                                    <ThemedButton
                                        className={'w-100 px-2 py-2 rounded-3 fw-semi-bold'}
                                        text={isFieldTrue(Fields.submitAsLoading) ? 'Sending Request...' : 'Request'}
                                        height={INPUT_H}
                                        elasticActive={true}
                                        loadingWidth={'100%'}
                                        asLoading={isFieldTrue(Fields.submitAsLoading)}
                                        disabled={isFieldTrue(Fields.submitDisable) || !isOnline}
                                        onClick={handleSubmit}
                                    />
                                </div>

                                {/*forgot-pw & request-access*/}
                                <Flexbox className={'w-100 mt-3 px-0'}
                                         justifyAt={'between'} justifyAtSm={'start'} alignAt={'center'}
                                         alignAtSm={'start'} wrap={'nowrap'} wrapSm={'nowrap'} directionSm={'column'}>
                                    <span></span>
                                    {/*request-access*/}
                                    <Flexbox className={'w-100 px-0'}
                                             justifyAt={'end'} alignAt={'center'}>
                                        <Label className={'text-nowrap m-0 p-0 bg-warningx mt-n1'}
                                               textAt={"start"}>
                                            Already have an account?{" "}
                                        </Label>

                                        <Anchor wrapperClassName={'m-0 p-0 ms-1'}
                                                className={'text-nowrap fw-semi-boldx bg-infox m-0 p-0 mt-1x'}
                                                href={GenRouteUrls.login}
                                        >
                                            {Modules.Login}
                                        </Anchor>
                                    </Flexbox>
                                </Flexbox>
                            </form>
                        </div>
                    </div>
                </div>
            </GridBox>
        </AuthPageLayout>
        {createSuccessDialog()}
    </>);

    function createSuccessDialog() {
        return <ThemedDialog
            open={isFieldTrue(Fields.showSuccessDialog)}
            title={getJsonValue(getField(Fields.successDialogContent), 'title')}
            showClose={true}
            showCancelControl={false}
            showConfirmControl={true}
            confirmText={'Close'}
            onHide={() => {
                const onHide = getJsonValue(getField(Fields.successDialogContent), 'onHide');
                if (onHide) onHide();
                updateField(Fields.showSuccessDialog, false);
                updateField(Fields.successDialogContent, {});
            }}
        >
            <div className={'px-2'}>
                <div className={'m-0 p-0 pt-1 px-2 d-none-smx h-100 auth-img-wrapper'}>
                    <Image
                        wrapperClassName={`w-100 rounded-4 overflow-hidden select-none`}
                        className={`auth-ra-img transition-sm`}
                        src={isJsonValueTrue(getField(Fields.successDialogContent), 'success') ? "https://images.unsplash.com/photo-1629906701520-7c0180c6e58f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" : "https://cdn.pixabay.com/photo/2016/02/06/15/15/stacked-1183047_1280.jpg"}
                        width={'100%'}
                        height={'240px'}
                        objectFit={'cover'}
                        disableDrag={true}
                    />
                </div>

                <h3 className={`text-wrap fs-xxl fw-bold text-center py-1 pt-3 ${isJsonValueTrue(getField(Fields.successDialogContent), 'success') ? 'text-success' : 'text-danger'}`}>
                    {getJsonValue(getField(Fields.successDialogContent), 'contentTitle')}
                </h3>
                <p className={'text-wrap py-1 text-start fs-normal'}>
                    {getJsonValue(getField(Fields.successDialogContent), 'content')}
                </p>
            </div>
        </ThemedDialog>
    }

    async function handleSubmit(e) {
        const fun = 'handleSubmit:';
        panelLog('');
        try {
            const formData = getFormRecord();
            let verified = await checkAllFieldsVerified(formData);
            // verified = false;
            log(fun, 'checkAllFieldsVerified.verified:', verified, 'formData:', formData);
            if (verified) {
                updateField(Fields.submitAsLoading, true);
                updateField(Fields.submitDisable, true);

                const REQUEST_OPTIONS = {data: formData, pageUrl: location.pathname, pageName: Modules.RequestAccess};

                sendRequest({
                    reqUrl: ReqUrls.requestAccess,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: (fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const alreadyExists = isJsonValueTrue(fetchedData, 'alreadyExists');

                        if (alreadyExists) {
                            panelLogErr(message);
                        } else {
                            //show dialog regardless of success: true/false
                            updateField(Fields.successDialogContent, {
                                title: 'Message', success: success, contentTitle: success ? "Congratulations" : "We're sorry!", content: message, onHide: (() => {
                                    log("Hide clicked.");
                                    if (success) {
                                        setFieldsData({});
                                        // window.location.href = GenRouteUrls.login;
                                        navigate(GenRouteUrls.login);
                                    }
                                })
                            });
                            updateField(Fields.showSuccessDialog, true);

                            // if (success) {
                            //     // panelLog(message);
                            // } else {
                            //     // panelLogErr(message);
                            // }
                        }
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                    }, onError: (error) => {
                        panelLogErr('Request failed, please try again');
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                        logErr(fun, error);
                    }
                });
            } else {

            }
        } catch (error) {
            panelLogErr('Request failed, please try again');
            updateField(Fields.submitAsLoading, false);
            updateField(Fields.submitDisable, false);
            logErr(fun, error);
        }
    }

    async function checkAllFieldsVerified(formData = {}) {
        const fun = 'checkAllFieldsVerified:';
        try {
            const requiredFields = [Fields.fullName, Fields.email, Fields.mobile, Fields.city, Fields.companyName,];
            if (getField(Fields.howYouFoundSelectedSrc) == HowYouFoundUsSrcs[0]) {
                requiredFields.push(Fields.howYouFoundColleague);
            }
            let verified = false;

            const emptyField = requiredFields.find((field) => !checkNullStr(formData[field]));
            if (emptyField) {
                updateField(Fields[emptyField + 'Msg'], 'Required field');
                focusIdField(emptyField);
                verified = false;
            } else {
                verified = true;
            }
            if (verified) {
                //validate each field
                const fullName = formData[Fields.fullName];
                const email = formData[Fields.email];
                // const landline = formData[Fields.landline];//already done in it's input
                // const mobile = formData[Fields.mobile];//already done in it's input
                const city = formData[Fields.city];
                const companyName = formData[Fields.companyName];
                if (checkNullStr(fullName)) {
                    let valid = FieldConfigs[Fields.fullName].regex.test(fullName);
                    updateField(Fields.fullNameMsg, valid ? '' : 'Invalid name');
                    panelLogErr(valid ? '' : 'Invalid name');
                    if (!valid) focusIdField(Fields.fullName);
                    verified = valid;
                    log(fun, `fullName: ${fullName}: VALID: `, valid);
                }
                if (checkNullStr(email) && verified) {
                    let valid = FieldConfigs[Fields.email].regex.test(email);
                    highlightIdField(Fields.email, !valid, Fields.emailMsg, !valid ? 'Invalid email' : '');
                    if (!valid) focusIdField(Fields.email);
                    verified = valid;
                    log(fun, `email: ${email}: VALID: `, valid);
                }
                if (checkNullStr(city) && verified) {
                    let valid = FieldConfigs[Fields.city].regex.test(city);
                    highlightIdField(Fields.city, !valid, Fields.cityMsg, !valid ? 'Invalid value' : '')
                    panelLogErr(valid ? '' : 'Invalid value');
                    if (!valid) focusIdField(Fields.city);
                    verified = valid;
                    log(fun, `city: ${city}: VALID: `, valid);
                }
                if (checkNullStr(companyName) && verified) {
                    let valid = FieldConfigs[Fields.companyName].regex.test(companyName);
                    highlightIdField(Fields.companyName, !valid, Fields.companyNameMsg, !valid ? 'Invalid value' : '')
                    panelLogErr(valid ? '' : 'Invalid value');
                    if (!valid) focusIdField(Fields.companyName);
                    verified = valid;
                    log(fun, `companyName: ${companyName}: VALID: `, valid);
                }
                //Validate with YUP
                // const validationSchemax = Yup.object({
                //     // product: Yup.string().required("Please select a product/").oneOf(products),
                //     [Fields.fullName]: Yup.string().required(), [Fields.email]: Yup.string().email().required(), // [Fields.landline]: Yup.string().mobile().required(),
                //     // rating: Yup.number().min(1).max(10).required(),
                //     // date: Yup.date().default(() => new Date()),
                //     // wouldRecommend: Yup.boolean().default(false),
                //     //username: Yup.string().required().minLength(3).maxLength(25),
                // });
                // const validationSchema = Yup.object().shape({
                //     [Fields.email]: Yup.string().required('Name is required'),
                //     [Fields.fullName]: Yup.string().email('Invalid email').required('Email is required'), // [Fields.fullName]: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required'),
                //     [Fields.landline]: Yup.string().matches(/^(?:(?![\s-]*[\s-])[0-9()-]){6,14}$/, 'Invalid mobile number').required('Mobile is required'),
                // });
                // validationSchema.validate(formData)
                //     .then((valid) => {
                //         log(fun, 'valid:', valid)
                //         return true;
                //     })
                //     .catch((error) => {
                //         panelLogErr(getJsonValue(error, 'message') + '');
                //         logErr(fun, 'Validation error:', error);
                //         log(fun, 'Validation error:', error);
                //         return false;
                //     });
                // if (errors.length > 0) {
                //     // There are errors in the form data
                // } else {
                //     // The form data is valid
                // }
            }
            return verified;
        } catch (e) {
            logErr(e);
            panelLogErr("Please fill the required fields");
            return false;
        }
    }

    function getFormRecord() {
        return {
            [Fields.fullName]: getField(Fields.fullName),
            [Fields.email]: getField(Fields.email),
            [Fields.landline]: getField(Fields.landline),
            [Fields.mobile]: getField(Fields.mobile),
            [Fields.city]: getField(Fields.city),
            [Fields.companyName]: getField(Fields.companyName),
            [Fields.howYouFoundSelectedSrc]: getField(Fields.howYouFoundSelectedSrc),
            [Fields.howYouFoundColleague]: getField(Fields.howYouFoundColleague),
        };
    }

    function canShowImage() {
        // return checkNullStr(getJsonValue(subdomainData, Keys.subdomain_RequestAccessImage)) && isJsonValueTrue(subdomainData, Keys.subdomain_ShowAuthPageImage);
        return true;
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function focusIdField(id, onlyFocus = true) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
        highlightIdField(id, true);
    }

    function highlightIdField(id, highlight = true, msgField, msg, variant = CssVariant.danger) {
        if (checkNullStr(msgField)) updateField(msgField, msg);
        addClass(getElement(id, 'id'), variant, isBoolTrue(highlight));
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default RequestAccessPage;
